import script from "./PixelBarStage.vue?vue&type=script&setup=true&lang=ts"
export * from "./PixelBarStage.vue?vue&type=script&setup=true&lang=ts"

import "./PixelBarStage.vue?vue&type=style&index=0&id=46a1f06e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/islander-vue-web/islander-vue-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46a1f06e"]])

export default __exports__